var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-state-viewer" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v(
        "STEP[" + _vm._s(_vm.value.order) + "]: " + _vm._s(_vm.value.blockName)
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-wrapper" }, [
      _c(
        "div",
        { staticClass: "btnGroup tabs" },
        _vm._l(["input", "output", "logs"], function (type) {
          return _c(
            "SupsisButton",
            {
              key: type,
              attrs: {
                classNames:
                  _vm.selectedTab === type
                    ? "btnGroupItem selected"
                    : "btnGroupItem ",
                primary: _vm.selectedTab === type,
                ghost: _vm.selectedTab !== type,
                small: "",
              },
              on: {
                click: function () {
                  return (_vm.selectedTab = type)
                },
              },
            },
            [_vm._v("\n                " + _vm._s(type) + "\n            ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "data-viewer" },
        [_c("vue-json-pretty", { attrs: { data: _vm.getData() } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }